import script from "./RecipeView.vue?vue&type=script&lang=ts&setup=true&async=true"
export * from "./RecipeView.vue?vue&type=script&lang=ts&setup=true&async=true"

import "./RecipeView.vue?vue&type=style&index=0&id=55046fec&scoped=true&lang=css"

import exportComponent from "E:\\Marianne\\workspace\\notion-cooks\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55046fec"]])

export default __exports__